export default __webpack_public_path__ + "static/media/hht1_home_img_EP14.ac6e29cb.png";